import React, { useState, useEffect, useCallback } from 'react';
import {
  LazyLoadImage,
  trackWindowScroll,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Header = ({ scrollPosition }) => {
  const [activeLink, setActiveLink] = useState('#hero');
  const sections = document.querySelectorAll('section');

  const mobileNavToggle = useCallback(() => {
    document.body.classList.toggle('mobile-nav-active');
    const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');
    if (mobileNavToggleBtn) {
      mobileNavToggleBtn.classList.toggle('bi-list');
      mobileNavToggleBtn.classList.toggle('bi-x');
    }
  }, []);

  const handleLinkClick = (hash) => {
    setActiveLink(hash);
    if (document.querySelector('.mobile-nav-active')) {
      mobileNavToggle();
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      let currentSection = '#hero';
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        if (window.scrollY >= sectionTop - sectionHeight / 3) {
          currentSection = `#${section.getAttribute('id')}`;
        }
      });
      setActiveLink(currentSection);
    };

    const debouncedHandleScroll = debounce(handleScroll, 100);
    window.addEventListener('scroll', debouncedHandleScroll);

    return () => window.removeEventListener('scroll', debouncedHandleScroll);
  }, [sections]);

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="#header" className="logo d-flex align-items-center me-auto">
          <LazyLoadImage
            src="/img/logors-512.webp"
            srcSet="/img/logors-256.webp 256w,
                    /img/logors-512.webp 512w,
                    /img/logors-1024.webp 1024w"
            sizes="(max-width: 768px) 100vw, 50vw"
            className="img-fluid"
            alt="Logo RSUD H. Abdul Manap Kota Jambi"
            effect="blur"
            scrollPosition={scrollPosition}
            width="200"
            height="131"
            loading="lazy"
          />
        </a>

        <nav id="navmenu" className="navmenu">
          <ul>
            {[
              { href: '#hero', label: 'Home' },
              { href: '#about', label: 'Tentang' },
              { href: '#services', label: 'Layanan' },
              { href: '#featured-services', label: 'Fasilitas' },
              { href: '#contact', label: 'Kontak' },
            ].map(({ href, label }) => (
              <li key={href}>
                <a
                  href={href}
                  className={activeLink === href ? 'active' : ''}
                  onClick={() => handleLinkClick(href)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>

          <i
            className="mobile-nav-toggle d-xl-none bi bi-list"
            onClick={mobileNavToggle}
          ></i>
        </nav>
        <a className="btn-getstarted" href="#contact">
          0741-5910180
        </a>
      </div>
    </header>
  );
};

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default trackWindowScroll(Header);
